import { addColumnHeader } from "../helpers";

export const invoiceGenerator = (
  worksheet,
  outputSheet,
  rules,
  rule,
  fileSettings,
  inputColumns,
  outputColumns,
) => {
  Object.entries(rule.customColumnMappings).forEach(([key, value]) => {
    addColumnHeader(outputSheet, outputColumns, value);
  });

  const useOutputOf = rules.find(
    (rle) => parseInt(rle._id) === parseInt(rule.useOutputOf),
  );

  const inputColumnMap = Object.fromEntries(
    inputColumns.map((col) => [col.inColChr, col]),
  );

  if (useOutputOf) {
    const referenceInputColumn = inputColumns.find(
      (clmObj) => clmObj.inColChr === useOutputOf.inputColumn,
    );

    if (useOutputOf.ranges) {
      insertInvoiceUsingRanges(
        worksheet,
        outputSheet,
        useOutputOf.output,
        rule,
        inputColumnMap,
        referenceInputColumn,
      );
    } else if (useOutputOf.appliedRule === 1) {
      const outputRows = {
        current: 2,
      };

      let dateColumn = inputColumns.find(
        (clmObj) => clmObj.inColChr === useOutputOf.dateColumn,
      );

      Object.entries(useOutputOf.output).forEach(([key, record], index) => {
        insertUsingGroubBy(
          outputSheet,
          rule,
          key,
          inputColumns,
          outputRows,
          dateColumn,
        );
      });
    } else {
      insertInvoiceUsingIndices(
        worksheet,
        outputSheet,
        useOutputOf,
        rule,
        inputColumnMap,
        referenceInputColumn,
      );
    }
  } else {
  }
};

const insertInvoiceUsingIndices = (
  worksheet,
  outputSheet,
  useOutputOf,
  rule,
  inputColumnMap,
  refData,
) => {
  let outputRow = {
    current: 2,
  };
  useOutputOf.output.forEach((rowIndex) => {
    let date = worksheet.getCell(`${useOutputOf.inputColumn}${rowIndex}`).value;
    console.log("🚀 ~ :84 ~ insertInvoiceUsingIndices ~ date:", date);
    processInvoiceRow(
      rule,
      inputColumnMap,
      worksheet,
      outputSheet,
      refData,
      rowIndex,
      outputRow,
      date,
    );
  });
};
const insertUsingGroubBy = (
  outputSheet,
  rule,
  key,
  inputColumns,
  outputRows,
  dateColumn,
) => {
  const [datepart, colDescription] = key.split("*");
  const inputColumnData = inputColumns.find(
    (clmObj) => clmObj.inColDesc.trim() === colDescription.trim(),
  );

  const outputCol = rule.customColumnMappings[inputColumnData.inColChr];

  let pattern = createInvoicePattern(
    inputColumnData.inColCharCode,
    rule,
    dateColumn.toDateFormat || dateColumn.inputDateFormat,
    datepart,
  );

  outputSheet.getCell(`${outputCol}${outputRows.current}`).value = pattern;
  outputRows.current += 1;
};
const processInvoiceRow = (
  rule,
  inputColumnMap,
  worksheet,
  outputSheet,
  refData,
  rowIndex,
  outputRow,
  date,
) => {
  Object.entries(rule.customColumnMappings).forEach(([key, value]) => {
    const inputColumnData = inputColumnMap[key];

    let hasData = null;
    hasData = worksheet.getCell(`${key}${rowIndex}`).value;

    if (
      (hasData === null || hasData === undefined || hasData === "") &&
      rule.skipEmptyCells
    ) {
      return;
    }

    if (rule.skipZeroValues && Number(hasData) === 0) return;

    let pattern = createInvoicePattern(
      inputColumnData.inColCharCode,
      rule,
      refData.toDateFormat,
      date,
    );

    outputSheet.getCell(`${value}${outputRow.current}`).value = pattern;
    outputRow.current += 1;
  });
};

const insertInvoiceUsingRanges = (
  worksheet,
  outputSheet,
  ranges,
  rule,
  inputColumns,
  refData,
) => {
  let currentRow = 2;
  for (let i = 0; i < ranges.length; i++) {
    const [startRow, endRow] = ranges[i];
    let date = worksheet.getCell(`${refData.inColChr}${startRow}`).value;
    for (let rowIndex = startRow + 1; rowIndex <= endRow; rowIndex++) {
      processInvoiceRow(
        rule,
        inputColumns,
        worksheet,
        outputSheet,
        refData,
        rowIndex,
        currentRow,
        date,
      );
      currentRow += 1;
    }
  }
};
const createInvoicePattern = (chrCode, rule, currentFormat, date) => {
  let pattern = "";
  rule.components.forEach((component) => {
    switch (component.type) {
      case "date":
        pattern += convertDate(
          component.format,
          component.separator,
          currentFormat,
          date,
        );
        break;
      case "separator":
        pattern += component.value;
        break;
      case "charCode":
        pattern += chrCode;
        break;
      case "text":
        pattern += component.value;
        break;
      default:
        return "";
    }
  });
  return pattern;
};
const convertDate = (targetFormat, separator, currentFormat, actualDate) => {
  // Helper function to parse month names
  const parseMonth = (monthStr) => {
    const months = {
      january: "01",
      february: "02",
      march: "03",
      april: "04",
      may: "05",
      june: "06",
      july: "07",
      august: "08",
      september: "09",
      october: "10",
      november: "11",
      december: "12",
      jan: "01",
      feb: "02",
      mar: "03",
      apr: "04",
      jun: "06",
      jul: "07",
      aug: "08",
      sep: "09",
      oct: "10",
      nov: "11",
      dec: "12",
    };
    return months[monthStr.toLowerCase()] || monthStr;
  };

  // Extract date parts based on currentFormat
  let day, month, year;

  if (currentFormat === "PPpp") {
    // Full Date & Time format - parse using Date object
    const dateObj = new Date(actualDate);
    day = String(dateObj.getDate()).padStart(2, "0");
    month = String(dateObj.getMonth() + 1).padStart(2, "0");
    year = String(dateObj.getFullYear());
  } else {
    // Determine the separator in currentFormat
    let currentSeparator = "";
    if (currentFormat.includes("/")) currentSeparator = "/";
    else if (currentFormat.includes("-")) currentSeparator = "-";
    else if (currentFormat.includes(",")) currentSeparator = ",";
    else if (currentFormat.includes(" ")) currentSeparator = " ";

    // Split actualDate and currentFormat
    const dateParts = currentSeparator
      ? actualDate.split(currentSeparator).map((p) => p.trim())
      : [actualDate];

    const formatParts = currentSeparator
      ? currentFormat.split(currentSeparator).map((p) => p.trim())
      : [currentFormat];

    // Map format parts to date parts
    formatParts.forEach((formatPart, index) => {
      const datePart = dateParts[index];

      if (formatPart.startsWith("yyyy")) {
        year = datePart;
      } else if (formatPart.startsWith("yy")) {
        year = datePart.length === 2 ? "20" + datePart : datePart;
      } else if (formatPart.startsWith("MMMM")) {
        month = parseMonth(datePart);
      } else if (formatPart.startsWith("MMM")) {
        month = parseMonth(datePart);
      } else if (formatPart.startsWith("MM")) {
        month = datePart.padStart(2, "0");
      } else if (formatPart.startsWith("dd")) {
        day = datePart.padStart(2, "0");
      } else if (formatPart.startsWith("d")) {
        day = datePart.padStart(2, "0");
      }
    });
  }

  // Ensure 2-digit formats
  const yy = year.slice(-2);

  // Build the target format
  let result = "";
  let i = 0;

  while (i < targetFormat.length) {
    if (targetFormat.substr(i, 4) === "yyyy") {
      result += year;
      i += 4;
    } else if (targetFormat.substr(i, 2) === "yy") {
      result += yy;
      i += 2;
    } else if (targetFormat.substr(i, 2) === "MM") {
      result += month;
      i += 2;
    } else if (targetFormat.substr(i, 2) === "dd") {
      result += day;
      i += 2;
    } else {
      i++;
    }
  }

  // Apply separator if provided
  // if (!separator) {
  //   return result;
  // }
  if (!separator || separator === "none") {
    return result;
  }

  // Insert separator based on targetFormat structure
  const formatParts = [];
  i = 0;
  while (i < targetFormat.length) {
    if (targetFormat.substr(i, 4) === "yyyy") {
      formatParts.push(4);
      i += 4;
    } else if (
      targetFormat.substr(i, 2) === "yy" ||
      targetFormat.substr(i, 2) === "MM" ||
      targetFormat.substr(i, 2) === "dd"
    ) {
      formatParts.push(2);
      i += 2;
    }
  }

  // Split result based on formatParts and join with separator
  let position = 0;
  const resultParts = formatParts.map((length) => {
    const part = result.substr(position, length);
    position += length;
    return part;
  });

  return resultParts.join(separator);
};
